import { useStaticQuery, graphql } from 'gatsby'

export const useDataPinsQuery = () => {
  const { wp, site } = useStaticQuery(graphql`
    query DataPinsQuery {
      wp {
        acfOptionsCommonItems {
          commonItems {
            dataPins {
              serviceAreasTitle
              cardsTitle
              quoteSvg {
                localFile {
                  publicURL
                }
              }
              defaultCardImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData(quality: 100)
                  }
                }
              }
            }
            footer {
              socialMedia {
                socialMediaLink {
                  url
                }
              }
            }
          }
        }
        nexvelSchemaMarkup {
          nexvelschema {
            businessType
            businessName
          }
        }
      }
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `)
  return { wp, site }
}
